export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";